import { gsap, ScrollTrigger, CSSPlugin } from "gsap/all";
import { ScrambleTextPlugin } from "../plugins/ScrambleTextPlugin";
import { DrawSVGPlugin } from "../plugins/DrawSVGPlugin";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";

gsap.registerPlugin(
  ScrollTrigger,
  DrawSVGPlugin,
  ScrambleTextPlugin,
  CSSPlugin
);

const galleryScale = (container, heading, landing) => {
  if (!container) return;

  const scaleVideo = container?.querySelector(".scale-video");
  const video = scaleVideo?.querySelector(".video");
  const scaleVideoWidth = scaleVideo.offsetWidth;
  const containerWidth = container.offsetWidth;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  const landingContainerRect = landing.getBoundingClientRect();
  const landingContainerHeight = landingContainerRect.height;
  const landingContainerWidth = landingContainerRect.width;

  const leftPosition = (containerWidth - scaleVideoWidth) / 2;

  let mm = gsap.matchMedia();

  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, () => {
    gsap.set(scaleVideo, {
      top: "0px",
      left: `${leftPosition}px`,
      transform: "translate(0, 0)",
    });

    gsap.set(heading, {
      y: 100,
    });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: container,
          start: "top top",
          end: "bottom bottom",
          pin: true,
          scrub: true,
          invalidateOnRefresh: true,
          onEnter: () => {
            video.play();
          },
          onLeave: () => {
            if (video.isPlaying) {
              video.pause();
            }
          },
          onEnterBack: () => {
            video.play();
          },
          onLeaveBack: () => {
            if (video.isPlaying) {
              video.pause();
            }
          },
        },
      })
      .to(scaleVideo, {
        width: viewportWidth,
        height: viewportHeight,
        top: "0px",
        left: "0px",
        transform: "translate(0, 0)",
      })
      .to(
        heading,
        {
          y: -100,
        },
        "end"
      )
      .to(
        scaleVideo,
        {
          width: landingContainerWidth,
          height: landingContainerHeight,
          left: () => {
            const landingRect = landing.getBoundingClientRect();
            return landingRect.left + "px";
          },
          top: () => {
            const landingRect = landing.getBoundingClientRect();
            return landingRect.top - 200 + "px";
          },
          transform: "translate(0, 0)",
        },
        "end"
      );
    return () => {
      gsap.to([scaleVideo, heading], { clearProps: "all" });
    };
  });

  mm.add(`(max-width: ${BREAKPOINTS.sm}px)`, () => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: container,
          start: "-=150 top",
          end: "bottom bottom",
          invalidateOnRefresh: true,
        },
      })
      .to(scaleVideo, {
        width: viewportWidth,
      });
    return () => {
      gsap.to(scaleVideo, { clearProps: "all" });
    };
  });
};

const galleryHorizontal = (container, galleryContainer) => {
  if (!container) return;

  gsap.set(galleryContainer, {
    x: "0px",
  });

  let images = [...container.querySelectorAll(".image-scroll")];

  const totalImageWidth = images.reduce((totalWidth, image) => {
    return totalWidth + image.offsetWidth;
  }, 0);

  gsap.to(images, {
    xPercent: -100 * (images.length - 1),
    ease: "none",
    scrollTrigger: {
      trigger: container,
      pin: true,
      anticipatePin: 1,
      scrub: 0.3,
      end: `${totalImageWidth}px`,
      invalidateOnRefresh: true,
    },
  });
};

const parallax = target => {
  if (!target) return;

  gsap.fromTo(
    target,
    { yPercent: -15 },
    {
      yPercent: 15,
      ease: "none",
      scrollTrigger: {
        trigger: target,
        scrub: 1,
      },
    }
  );
};

const animations = {
  ...gsap,
  ScrollTrigger: ScrollTrigger,
  ScrambleTextPlugin: ScrambleTextPlugin,
  DrawSVGPlugin: DrawSVGPlugin,
  galleryScale: galleryScale,
  galleryHorizontal: galleryHorizontal,
  parallax: parallax,
};

export default animations;
